module.exports = __webpack_public_path__ + "static/attendee.7388b822.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/attendee.jpg
// module id = 984
// module chunks = 101932004231744